export default "__VITE_PUBLIC_ASSET__a74510ab__"